// Body of the Oscar account-registration view: the account-page layout -- the
// brand heading, the ConvertLazyUserForm rendered as a native React field
// tree, the decorative account image, and the customer-service info block.
// The headings / submit label / decorative image arrive pre-resolved as props
// (server-side gettext + per-APP_SLUG branding); the customer-service block
// travels as the `cs_info_json` seam.
import { Immutable } from "immer";
import React from "react";
import { FormFields } from "tsi-common-react/src/apps/customer-account/FormFields/index";
import { duplicateEmailAfterField } from "tsi-common-react/src/forms/DuplicateEmailError/index";
import {
    FORM_CLASS_NAME,
    FORM_FIELD_SUBMIT_CLASS_NAME,
} from "tsi-common-react/src/forms/classNames";
import { useStaticURL } from "tsi-common-react/src/utils/urls";

import { templates } from "@reactivated";

import { CSRFToken } from "@reactivated/forms";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { AuthCustomerServiceBlock } from "../AuthCustomerServiceBlock";

type IProps = Immutable<templates.RegistrationDocumentTemplate>;

export const RegistrationBody = (props: IProps): React.JSX.Element => {
    const staticURL = useStaticURL();
    return (
        <div className="l-capped-width">
            <div className="account-page-title">
                <h1>{props.page_copy?.page_heading}</h1>
            </div>

            <section className="account-page-container">
                <div>
                    <h2>{props.page_copy?.section_heading}</h2>
                    <div>
                        <form
                            className={concatClassNames([
                                FORM_CLASS_NAME,
                                "js-kuid-form",
                            ])}
                            method="post"
                            action={props.action_url}
                        >
                            <CSRFToken />
                            <FormFields
                                fields={props.fields}
                                field_labels={props.field_labels}
                                field_errors={props.field_errors}
                                non_field_errors={props.non_field_errors}
                                afterField={duplicateEmailAfterField(props)}
                                showRequiredLegend
                            />
                            <div className={FORM_FIELD_SUBMIT_CLASS_NAME}>
                                <input
                                    type="submit"
                                    className="button button--full-width"
                                    value={props.page_copy?.submit_text}
                                />
                            </div>
                        </form>
                    </div>
                </div>
                <div>
                    {props.page_copy?.account_image ? (
                        <img
                            src={`${staticURL}img/accounts/${props.page_copy.account_image}`}
                            alt={props.page_copy.account_image_alt}
                        />
                    ) : null}
                </div>
            </section>

            <AuthCustomerServiceBlock payload={props.cs_info_json} />
        </div>
    );
};
